import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import AttributeCodebookForm from "./AttributeCodebookForm";
import ValueListItem, { IValueListItem } from "../../../model/valuelist/ValueListItem";

export interface State {}

export interface UpdateAttributeCodebookFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IValueListItem;
}

class UpdateAttributeCodebookForm extends React.Component<
  UpdateAttributeCodebookFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let updateAttributeCodebook;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          updateAttributeCodebook = ValueListItem(values);
          updateAttributeCodebook.code = rowData.code;
        }
      });
      return updateAttributeCodebook;
    });
  }

  render() {
    const { translate, rowData } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <AttributeCodebookForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
      />
    );
  }
}

export default UpdateAttributeCodebookForm;
